// extracted by mini-css-extract-plugin
module.exports = {"comp":"Comp_comp__1_lxI","ImageContainer":"Comp_ImageContainer__347OE","compImg":"Comp_compImg__1qcQH","text":"Comp_text__1_iIN"};